export const maliciousExtensions = [
  // 실행 파일 및 스크립트
  ".exe", // Windows 실행 파일
  ".bat", // 배치 파일
  ".cmd", // 명령어 파일
  ".com", // 명령어 파일
  ".msi", // Windows 설치 파일
  ".sh", // Linux/Unix 쉘 스크립트
  ".jar", // Java 실행 파일
  ".vbs", // VBScript 파일
  ".js", // JavaScript 파일
  ".wsf", // Windows Script File
  ".scr", // 화면 보호기 파일 (실행 가능)
  ".pif", // 프로그램 정보 파일
  ".ps1", // PowerShell 스크립트 파일
  ".apk", // Android 애플리케이션 패키지
  ".gadget", // Windows Gadget 파일

  // 문서 파일 (내부에 스크립트를 포함할 수 있는 형식)
  ".doc", // Microsoft Word 문서 (매크로 악성코드 포함 가능)
  ".docx", // Microsoft Word 문서
  ".xls", // Microsoft Excel 파일 (매크로 악성코드 포함 가능)
  ".xlsx", // Microsoft Excel 파일
  ".ppt", // Microsoft PowerPoint 파일 (매크로 악성코드 포함 가능)
  ".pptx", // Microsoft PowerPoint 파일
  ".rtf", // 리치 텍스트 형식 (취약점 악용 가능)
  ".pdf", // PDF 파일 (취약점 악용 가능)

  // 압축 파일 (압축된 악성 파일 포함 가능)
  ".zip", // ZIP 압축 파일
  ".rar", // RAR 압축 파일
  ".7z", // 7-Zip 압축 파일
  ".tar", // TAR 아카이브 파일
  ".gz", // GZIP 압축 파일
  ".bz2", // BZIP2 압축 파일

  // 웹 파일 (웹 브라우저를 통해 악성 코드가 실행될 수 있음)
  ".html", // HTML 파일
  ".htm", // HTML 파일
  ".php", // PHP 스크립트 파일
  ".asp", // Active Server Page 파일
  ".aspx", // ASP.NET 파일

  // 미디어 파일 (취약점을 악용해 악성 코드 실행 가능)
  ".swf", // Adobe Flash 파일
  ".flv", // Flash 비디오 파일
  ".mp4", // 비디오 파일 (특정 경우 악성코드 포함 가능)
  ".avi", // 비디오 파일 (특정 경우 악성코드 포함 가능)
] as const;
